document.addEventListener("DOMContentLoaded", () => {
  // 라이브러리 존재 여부 확인
  if (typeof Swiper === 'undefined' || typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
    console.warn('Required libraries (Swiper, GSAP, ScrollTrigger) not loaded for latest news');
    return;
  }


  // DOM 요소 확인
  const $homeLatestNews = document.getElementById('homeLatestNews');
  if (!$homeLatestNews) return;

  const $swiperContainer = $homeLatestNews.querySelector('.swiper');
  const $prevBtn = $homeLatestNews.querySelector('.__prev');
  const $nextBtn = $homeLatestNews.querySelector('.__next');

  if (!$swiperContainer || !$prevBtn || !$nextBtn) {
    console.warn('Required elements not found for news slider');
    return;
  }

  let swiper = null;

  try {
    // Swiper 초기화
    swiper = new Swiper($swiperContainer, {
      slidesPerView: 'auto',
      spaceBetween: 0,
      navigation: {
        nextEl: $nextBtn,
        prevEl: $prevBtn,
        disabledClass: 'swiper-button-disabled'
      },
      pagination: {
        el: '.news-slides .swiper-pagination',
        clickable: true,
        type: 'bullets'
      },
      breakpoints: {
        640: {
          slidesPerView: 1,
        },
        768: {
          slidesPerView: 2,
        },
        1024: {
          slidesPerView: 3,
        }
      },
      a11y: {
        enabled: true,
        prevSlideMessage: 'Previous news article',
        nextSlideMessage: 'Next news article',
        firstSlideMessage: 'This is the first news article',
        lastSlideMessage: 'This is the last news article'
      },
      keyboard: {
        enabled: true,
        onlyInViewport: true
      },
      // 접근성을 위한 이벤트
      on: {
        slideChange: function() {
          // 스크린리더를 위한 현재 슬라이드 정보
          const activeSlide = this.slides[this.activeIndex];
          const title = activeSlide?.querySelector('.__title')?.textContent;
          if (title) {
            // 간단한 알림을 위한 aria-live 영역 업데이트
            const announcement = `Now viewing: ${title}`;
            const existingAnnouncer = document.getElementById('slide-announcer');
            if (existingAnnouncer) {
              existingAnnouncer.textContent = announcement;
            } else {
              const announcer = document.createElement('div');
              announcer.id = 'slide-announcer';
              announcer.className = 'sr-only';
              announcer.setAttribute('aria-live', 'polite');
              announcer.textContent = announcement;
              $homeLatestNews.appendChild(announcer);
            }
          }
        }
      }
    });

    // 버튼 상태 업데이트
    const updateButtonStates = () => {
      if (swiper) {
        $prevBtn.disabled = swiper.isBeginning;
        $nextBtn.disabled = swiper.isEnd;
        $prevBtn.setAttribute('aria-disabled', swiper.isBeginning);
        $nextBtn.setAttribute('aria-disabled', swiper.isEnd);
      }
    };

    // 초기 상태 설정
    updateButtonStates();

    // 슬라이드 변경 시 버튼 상태 업데이트
    swiper.on('slideChange', updateButtonStates);

  } catch (error) {
    console.warn('Swiper initialization failed:', error);
  }

  // News item image aspect ratio check
  $homeLatestNews.querySelectorAll('.news-post-loop .__tb img').forEach(img => {
    const checkImageAspect = () => {
      if (img.naturalWidth && img.naturalHeight) {
        const aspectRatio = img.naturalWidth / img.naturalHeight;
        // If image is wider than 16:9 (more horizontal), use contain
        if (aspectRatio > 16/9) {
          img.classList.add('--contain');
        } else {
          img.classList.remove('--contain');
        }
      }
    };
    
    if (img.complete) {
      checkImageAspect();
    } else {
      img.addEventListener('load', checkImageAspect);
    }
  });

  // GSAP 애니메이션 (접근성 고려)
  if (!window.prefersReducedMotion) {
    const newsPostLoops = $homeLatestNews.querySelectorAll('.news-post-loop');
    return;
    if (newsPostLoops.length > 0) {
      try {
        // 초기 상태 설정
        newsPostLoops.forEach(item => {
          const tb = item.querySelector('.__tb');
          const desc = item.querySelector('.__desc');
          const img = tb?.querySelector('.img');

          if (tb && desc) {
            gsap.set(tb, {
              yPercent: 100,
              skewY: 6,
              skewX: 8,
              opacity: 0
            });

            if (img) {
              gsap.set(img, {
                filter: 'grayscale(100%)',
                scale: 1.6,
                skewY: -6,
                skewX: -8
              });
            }

            gsap.set(desc, {
              y: 80,
              opacity: 0
            });
          }
        });

        // ScrollTrigger 애니메이션
        ScrollTrigger.create({
          trigger: $homeLatestNews.querySelector('.news-slides'),
          start: 'top 80%',
          end: 'bottom bottom',
          once: true,
          onEnter: () => {
            const tl = gsap.timeline();

            newsPostLoops.forEach((item, index) => {
              const delay = index * 0.2;
              const tb = item.querySelector('.__tb');
              const desc = item.querySelector('.__desc');
              const img = tb?.querySelector('.img');

              if (tb && desc) {
                // 이미지 컨테이너 애니메이션
                tl.to(tb, {
                  yPercent: 0,
                  skewY: 0,
                  skewX: 0,
                  opacity: 1,
                  duration: 1,
                  ease: 'circ.out'
                }, delay);

                // 이미지 애니메이션
                if (img) {
                  tl.to(img, {
                    filter: 'grayscale(0%)',
                    scale: 1,
                    skewY: 0,
                    skewX: 0,
                    duration: 1,
                    ease: 'circ.out'
                  }, delay);
                }

                // 텍스트 애니메이션
                tl.to(desc, {
                  y: 0,
                  opacity: 1,
                  duration: 1.2,
                  ease: 'power3.out'
                }, delay + 0.3);
              }
            });
          }
        });

      } catch (error) {
        console.warn('GSAP animation setup failed:', error);
      }
    }
  } else {
    // 접근성: 애니메이션 비활성화 시 즉시 표시
    const newsPostLoops = $homeLatestNews.querySelectorAll('.news-post-loop');
    newsPostLoops.forEach(item => {
      const tb = item.querySelector('.__tb');
      const desc = item.querySelector('.__desc');
      if (tb) tb.style.opacity = '1';
      if (desc) desc.style.opacity = '1';
    });
  }

  // 정리 함수
  const cleanup = () => {
    try {
      swiper?.destroy(true, true);
    } catch (error) {
      console.warn('Swiper cleanup failed:', error);
    }
  };

  // 페이지 가시성 변경 시 처리
  document.addEventListener('visibilitychange', () => {
    if (document.hidden && swiper) {
      swiper.autoplay?.stop();
    }
  });

});